import Top from '../views/Top.vue'
import Login from '../views/Login.vue'
import Maintenance from '../views/Maintenance'
import Error from '../views/Error.vue'
import Reminder from '../views/Reminder.vue'
import ChangePassword from '../views/ChanagePassword.vue'
import AccountEntry from '../views/account/Entry.vue'
import TermsOfUse from '../views/account/TermsOfUse.vue'
import AccountChange from '../views/account/Change.vue'
import GroupAccountList from '../views/group/account/List.vue'
import GroupAccountDetail from '../views/group/account/Detail.vue'
import GroupAccountEntryList from '../views/group/account/entry/List.vue'
import GroupAccountEntryDetail from '../views/group/account/entry/Detail.vue'
import AdminAccountEntryList from '../views/admin/account/entry/List.vue'
import AdminAccountServiceApplicationList from '../views/admin/account/service/application/List.vue'
import AdminAccountServiceApplicationDetail from '../views/admin/account/service/application/Detail.vue'
import AdminAccountEntryDetail from '../views/admin/account/entry/Detail.vue'
import AdminAccountEntryChange from '../views/admin/account/entry/Change.vue'
import AdminAccountList from '../views/admin/account/List.vue'
import AdminAccountDetail from '../views/admin/account/Detail.vue'
import AdminAccountAdd from '../views/admin/account/Add.vue'
import AdminAccountChangeGroup from '../views/admin/account/ChangeGroup.vue'
import AdminMstGroupList from '../views/admin/mst/group/List.vue'
import AdminMstGroupDetail from '../views/admin/mst/group/Detail.vue'
import AdminMstGroupAdd from '../views/admin/mst/group/Add.vue'
import AdminMstCompanyList from '../views/admin/mst/company/List.vue'
import AdminMstCompanyAdd from '../views/admin/mst/company/Add.vue'
import AdminMstCompanyDetail from '../views/admin/mst/company/Detail.vue'
import AdminMstBranchAdd from '../views/admin/mst/branch/Add.vue'
import AdminMstBranchDetail from '../views/admin/mst/branch/Detail.vue'
import AdminMstServiceList from '../views/admin/mst/service/List.vue'
import AdminMstServiceDetail from '../views/admin/mst/service/Detail.vue'
import AdminMstServiceAdd from '../views/admin/mst/service/Add.vue'
import AdminSendMailSend from '../views/admin/sendmail/Send.vue'

export default [
  {
    path: '/login',
    name: 'login',
    meta: { layout: 'simple' },
    component: Login
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { layout: 'simple' },
    component: Maintenance
  },
  {
    path: '/error',
    name: 'error',
    meta: { layout: 'simple' },
    component: Error
  },
  {
    path: '/reminder',
    name: 'reminder',
    meta: { layout: 'simple' },
    component: Reminder
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { layout: 'simpleLogout', requiresAuth: true },
    component: ChangePassword
  },
  {
    path: '/',
    name: 'Top',
    meta: { requiresAuth: true },
    component: Top
  },
  {
    path: '/account/entry',
    name: 'AccountEntry',
    meta: { layout: 'simple' },
    component: AccountEntry
  },
  {
    path: '/account/terms-of-use',
    name: 'TermsOfUse',
    meta: { layout: 'simple' },
    component: TermsOfUse
  },
  {
    path: '/account/change',
    name: 'AccountChange',
    meta: { requiresAuth: true },
    component: AccountChange
  },
  {
    path: '/group/account/list',
    name: 'GroupAccountList',
    meta: { requiresAuth: true, requiresGroupAdminAuth: true },
    component: GroupAccountList
  },
  {
    path: '/group/account/detail/:id',
    name: 'GroupAccountDetail',
    meta: { requiresAuth: true, requiresGroupAdminAuth: true },
    component: GroupAccountDetail
  },
  {
    path: '/group/account/entry/list',
    name: 'GroupAccountEntryList',
    meta: { requiresAuth: true, requiresGroupAdminAuth: true },
    component: GroupAccountEntryList
  },
  {
    path: '/group/account/entry/detail/:id',
    name: 'GroupAccountEntryDetail',
    meta: { requiresAuth: true, requiresGroupAdminAuth: true },
    component: GroupAccountEntryDetail
  },
  {
    path: '/admin/account/entry/list',
    name: 'AdminAccountEntryList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountEntryList
  },
  {
    path: '/admin/account/service/application/list',
    name: 'AdminAccountServiceApplicationList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountServiceApplicationList
  },
  {
    path: '/admin/account/service/application/detail/:id',
    name: 'AdminAccountServiceApplicationDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountServiceApplicationDetail
  },
  {
    path: '/admin/account/entry/detail/:id',
    name: 'AdminAccountEntryDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountEntryDetail
  },
  {
    path: '/admin/account/entry/change/:id',
    name: 'AdminAccountEntryChange',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountEntryChange
  },
  {
    path: '/admin/account/list',
    name: 'AdminAccountList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountList
  },
  {
    path: '/admin/account/detail/:id',
    name: 'AdminAccountDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountDetail
  },
  {
    path: '/admin/account/add',
    name: 'AdminAccountAdd',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountAdd
  },
  {
    path: '/admin/account/changegroup',
    name: 'AdminAccountChangeGroup',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminAccountChangeGroup
  },
  {
    path: '/admin/mst/group/list',
    name: 'AdminMstGroupList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstGroupList
  },
  {
    path: '/admin/mst/group/detail/:id',
    name: 'AdminMstGroupDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstGroupDetail
  },
  {
    path: '/admin/mst/group/add',
    name: 'AdminMstGroupAdd',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstGroupAdd
  },
  {
    path: '/admin/mst/company/list',
    name: 'AdminMstCompanyList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstCompanyList
  },
  {
    path: '/admin/mst/company/add',
    name: 'AdminMstCompanyAdd',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstCompanyAdd
  },
  {
    path: '/admin/mst/company/detail/:id',
    name: 'AdminMstCompanyDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstCompanyDetail
  },
  {
    path: '/admin/mst/company/:companyId/branch/add/',
    name: 'AdminMstBranchAdd',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstBranchAdd
  },
  {
    path: '/admin/mst/branch/detail/:id',
    name: 'AdminMstBranchDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstBranchDetail
  },
  {
    path: '/admin/mst/service/list',
    name: 'AdminMstServiceList',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstServiceList
  },
  {
    path: '/admin/mst/service/detail/:id',
    name: 'AdminMstServiceDetail',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstServiceDetail
  },
  {
    path: '/admin/mst/service/add',
    name: 'AdminMstServiceAdd',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminMstServiceAdd
  },
  {
    path: '/admin/sendmail',
    name: 'AdminSendMailSend',
    meta: { requiresAuth: true, requiresAdminAuth: true },
    component: AdminSendMailSend
  },
  // TODO: あとでグループ責任者と管理者の画面は利用するときにコンポーネントを読み込むようにした方が良いかも
  // {
  //   path: '/about',
  //   name: 'About',
  //   meta: { requiresAuth: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '*',
    redirect: '/login'
  }
]
